import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const adminData = localStorage.getItem("admin");
    return adminData ? JSON.parse(adminData) : null;
  });

  const logout = () => {
    setUser(null);
    localStorage.removeItem("admin");
  };

  // Keep user in sync with localStorage in case it changes in another tab
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "admin") {
        const adminData = event.newValue ? JSON.parse(event.newValue) : null;
        setUser(adminData);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


// import React, {
//   createContext,
//   useState,
//   useEffect,
// } from "react";

// export const AuthContext =
//   createContext();

// export const AuthProvider =
// ({ children }) => {

//   /* =========================================
//      TEST ADMIN LOGIN
//   ========================================= */

//   const [user, setUser] =
//     useState(() => {

//       const adminData =
//         localStorage.getItem(
//           "admin"
//         );

//       /* =========================================
//          IF ADMIN EXISTS
//       ========================================= */

//       if (adminData) {

//         return JSON.parse(
//           adminData
//         );
//       }

//       /* =========================================
//          AUTO LOGIN FOR TESTING
//       ========================================= */

//       const testAdmin = {

//         _id: "test-admin-id",

//         name: "Test Admin",

//         email:
//           "admin@sacmtb.com",

//         role: "admin",

//         token:
//           "testing-token",
//       };

//       localStorage.setItem(

//         "admin",

//         JSON.stringify(
//           testAdmin
//         )
//       );

//       return testAdmin;
//     });

//   /* =========================================
//      LOGOUT
//   ========================================= */

//   const logout = () => {

//     setUser(null);

//     localStorage.removeItem(
//       "admin"
//     );

//     /* OPTIONAL:
//        AUTO RELOGIN AFTER LOGOUT
//     */

//     window.location.reload();
//   };

//   /* =========================================
//      STORAGE SYNC
//   ========================================= */

//   useEffect(() => {

//     const handleStorage =
//     (event) => {

//       if (
//         event.key === "admin"
//       ) {

//         const adminData =

//           event.newValue

//             ? JSON.parse(
//                 event.newValue
//               )

//             : null;

//         setUser(adminData);
//       }
//     };

//     window.addEventListener(
//       "storage",
//       handleStorage
//     );

//     return () =>

//       window.removeEventListener(
//         "storage",
//         handleStorage
//       );

//   }, []);

//   /* =========================================
//      PROVIDER
//   ========================================= */

//   return (

//     <AuthContext.Provider

//       value={{

//         user,

//         setUser,

//         logout,
//       }}
//     >

//       {children}

//     </AuthContext.Provider>
//   );
// };